const a = () => {
  const { hostname: o } = window.location;
  return o.endsWith(".dev.propify.com");
}, l = () => {
  const { hostname: o } = window.location;
  return o.includes("tenant-client-");
}, c = () => process.env.NODE_ENV === "development" ? "local" : process.env.NODE_ENV === "production" && !a() ? "production" : "stage", s = () => c() === "production", d = () => window.propifySdk, i = (o, e, n) => o.reduce((r, t) => ({ ...r, [e(t)]: n ? n(t) : t }), {}), g = (o, e) => {
  const n = localStorage.getItem(o);
  localStorage.setItem(o, e), window.dispatchEvent(
    new StorageEvent("storage", {
      key: o,
      oldValue: n,
      newValue: e,
      storageArea: localStorage,
      url: window.location.href
    })
  );
}, u = (o) => {
  const e = localStorage.getItem(o);
  localStorage.removeItem(o), !(e === void 0 || e == null) && window.dispatchEvent(
    new StorageEvent("storage", {
      key: o,
      oldValue: e,
      newValue: void 0,
      storageArea: localStorage,
      url: window.location.href
    })
  );
};
export {
  i as arrayToMap,
  l as domainIncludesTenantClient,
  c as getEnvironment,
  s as isProd,
  d as isSDK,
  u as removeItemInLocalStorageAndSendEvent,
  g as setItemInLocalStorageAndSendEvent
};
//# sourceMappingURL=utils.js.map
